(function () {
  if (window.__SM_BS_INIT__) return;
  window.__SM_BS_INIT__ = true;

  function formatETA(d) {
    return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" }).replace(",", "");
  }

  function nextDayOfWeek(fromDate, targetDay) {
    var d = new Date(fromDate.getTime());
    while (d.getDay() !== targetDay) d.setDate(d.getDate() + 1);
    return d;
  }

  function getNextWorkingCutoff(now, cutoffHour) {
    var target = new Date(now);
    target.setHours(cutoffHour, 0, 0, 0);

    if (target <= now || now.getDay() === 6 || now.getDay() === 0) {
      do { target.setDate(target.getDate() + 1); }
      while (target.getDay() === 6 || target.getDay() === 0);
      target.setHours(cutoffHour, 0, 0, 0);
    }
    return target;
  }

  function initCarousel(carousel) {
    if (carousel.__smInit) return;
    carousel.__smInit = true;

    var track = carousel.querySelector("[data-sm-bs-track]");
    var container = carousel.closest(".sm-bs-container");
    if (!track || !container) return;

    var prevBtn = container.querySelector("[data-sm-bs-prev]");
    var nextBtn = container.querySelector("[data-sm-bs-next]");
    if (!prevBtn || !nextBtn) return;

    function updateButtons() {
      var maxScrollLeft = track.scrollWidth - track.clientWidth - 5;
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft >= maxScrollLeft;
    }

    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -track.clientWidth, behavior: "smooth" });
    });

    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: track.clientWidth, behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons);
    window.addEventListener("resize", updateButtons);
    updateButtons();
  }

  function initDeliveryBadge(wrap) {
    if (wrap.__smInit) return;
    wrap.__smInit = true;

    var cutoffHour = 15;
    var cutoffAttr = wrap.getAttribute("data-cutoff-hour");
    if (cutoffAttr) {
      var parsed = parseInt(cutoffAttr, 10);
      if (!isNaN(parsed)) cutoffHour = parsed;
    }

    var labelEl = wrap.querySelector("[data-sm-bs-label]");
    var timerEl = wrap.querySelector("[data-sm-bs-timer]");
    var noteEl = wrap.querySelector("[data-sm-bs-note]");
    if (!timerEl) return;

    function applyWeekendOrFridayMessage(now) {
      var day = now.getDay(); // 0 Sun, 5 Fri, 6 Sat
      var hour = now.getHours();

      var etaDate;
      if (day === 5) {
        // Friday, before cutoff => Monday, after cutoff => Tuesday
        etaDate = (hour >= cutoffHour) ? nextDayOfWeek(now, 2) : nextDayOfWeek(now, 1);
      } else {
        // Saturday, Sunday => Tuesday
        etaDate = nextDayOfWeek(now, 2);
      }

      if (labelEl) labelEl.style.display = "none";
      timerEl.textContent = "Order now, get it by: " + formatETA(etaDate);
      if (noteEl) noteEl.textContent = "On eligible in-stock items only.";
    }

    var cutoffTime = getNextWorkingCutoff(new Date(), cutoffHour);

    function tick() {
      var now = new Date();
      var day = now.getDay();

      // Friday, Saturday, Sunday rules
      if (day === 5 || day === 6 || day === 0) {
        applyWeekendOrFridayMessage(now);
        return;
      }

      // Mon–Thu countdown
      if (now >= cutoffTime) cutoffTime = getNextWorkingCutoff(now, cutoffHour);

      var diffMs = cutoffTime - now;
      var totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (labelEl) labelEl.style.display = "";
      timerEl.textContent =
        "Order in " +
        String(hours).padStart(2, "0") + "h " +
        String(minutes).padStart(2, "0") + "m " +
        String(seconds).padStart(2, "0") + "s";
    }

    tick();
    setInterval(tick, 1000);
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-sm-bs-carousel]").forEach(initCarousel);
    (root || document).querySelectorAll("[data-sm-bs-delivery]").forEach(initDeliveryBadge);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);

    // Supports Shopify section rendering in theme editor
    document.addEventListener("shopify:section:load", function (e) {
      initAll(e.target);
    });
  });
})();
